import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { Box } from '@interstate/components/Box';

const shimmer = keyframes`
    0% { background-position: -200px 0; }
    100% { background-position: calc(200px + 100%) 0; }
`;

export const SkeletonContainer = styled(Box)`
    && {
        display: flex;
        flex-direction: column;
        gap: ${rem(8)};
        width: 100%;
        height: 100%;
        padding: ${rem(8)};
        box-sizing: border-box;
        justify-content: center;
    }
`;

export const ShimmerBar = styled.div<{ $width?: string; $height?: string }>`
    width: ${({ $width }) => $width ?? '100%'};
    height: ${({ $height }) => $height ?? rem(10)};
    border-radius: ${rem(2)};
    background: linear-gradient(90deg, #e8e8e8 0%, #f4f4f4 50%, #e8e8e8 100%);
    background-size: 200px 100%;
    animation: ${shimmer} 1.4s ease-in-out infinite;
`;
